import { ApplicationTableItem } from "../types";

export const loanDetailHiddenColumns = [
  "heloc",
  "mortgageAmountPremiumsIncluded",
  "loanValue",
  "productType",
  "rate",
  "closingDate",
] as const satisfies readonly (keyof ApplicationTableItem)[];

export const legacyHiddenColumns = [
  "rate",
  "closingDate",
] as const satisfies readonly (keyof ApplicationTableItem)[];

export const externalBrokerHiddenColumns = [
  "tenantReferralId",
  "isDigital",
  "rate",
] as const satisfies readonly (keyof ApplicationTableItem)[];
